import { TIME_RANGES } from '../../../constants'
import type { TimeRangeKey } from '../../../types'
import type { PriceData } from '../types'

export function filterDataByTimeRange(
  data: PriceData[], 
  timeRange: TimeRangeKey
): PriceData[] {
  if (timeRange === 'MAX') return data

  const { days } = TIME_RANGES[timeRange]
  const cutoffDate = new Date()
  cutoffDate.setDate(cutoffDate.getDate() - days)

  return data.filter(item => {
    // const itemDate = new Date(item.r)
    const itemDate = new Date(item.d)
    return itemDate >= cutoffDate
  })
}